import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

/**
 * Lightweight hover tooltip matching the skill's black/white treatment.
 * Prototype-grade (CSS group-hover, no Radix), but the same visual contract.
 */
export function Tooltip({
  content,
  side = 'top',
  children,
  className,
}: {
  content: ReactNode;
  side?: 'top' | 'right';
  children: ReactNode;
  className?: string;
}) {
  const position =
    side === 'right'
      ? 'left-full top-1/2 ml-2 -translate-y-1/2'
      : 'bottom-full left-1/2 mb-2 -translate-x-1/2';
  return (
    <span className={cn('group relative inline-flex', className)}>
      {children}
      <span
        className={cn(
          'pointer-events-none absolute z-30 hidden w-max max-w-xs whitespace-normal rounded-md bg-black px-3 py-1.5 text-sm font-normal text-white opacity-90 shadow-md group-hover:block',
          position,
        )}
      >
        {content}
      </span>
    </span>
  );
}
